export default "__VITE_ASSET__mUfmtjkQ__"